<template>

	<template
		v-if="isAuth && isEmailConfirmed"
	>
		<slot></slot>
	</template>
	<NotAuthorizedWindow
		v-else
	/>

</template>

<script setup>
/**
 * @description этот компонент отвечает за логику аутентификации пользователя и за отключение прелоадера
 */
import { /* computed, watch, */ onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'

/* Components */
import NotAuthorizedWindow from '@/components/windows/NotAuthorizedWindow.vue'
// import AuthorizedWindow from '@/components/windows/AuthorizedWindow.vue'

/* Stores */
import { useUserStore } from '@/stores/userStore'

/* Configs */
import { ROUTER_QUERY_KEYS } from '@/config/router/routerMapConfig.js'

const route = useRoute()
const router = useRouter()

const userStore = useUserStore()

const {
	isAuth,
	isEmailConfirmed,
} = storeToRefs(userStore)

onMounted(() => {
	router.isReady()
		.then(async () => {
			const queryLocale = route.query[ROUTER_QUERY_KEYS.APP_LOCALE]
			if (queryLocale) {
				const newQuery = {
					...route.query,
				}
				delete newQuery[ROUTER_QUERY_KEYS.APP_LOCALE]
				router.replace({
					query: newQuery,
				})
			}

			const firstPreloader = window.document.querySelector('#app-dark-logo-preloader')
			if (firstPreloader) firstPreloader.style.display = 'none'
		})
})
</script>

<style lang="scss">
@import '@/assets/scss/typography.scss';
@import '@/assets/scss/color.scss';
</style>
